<template>
  <div class="dd-aa">
    <van-nav-bar
      title="幸运抽奖"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
      "
    >
      <Zz
        v-if="prizes.length > 0"
        ref="LuckDraw"
        :config="config"
        :prizes="prizes"
        :btnConfig="btnConfig"
        @start="startCallBack"
        @end="endCallBack"
      />
    </div>
    <div class="zjjilu">
      <p style="margin-bottom: 20px">我的积分：{{ objU.integral }}</p>
      <p>抽奖1/次消耗{{ objU.zhpan_jifen }}积分</p>
      <button
        @click="wayLists"
        style="
          background: linear-gradient(90deg, #ffb43b 0, #ff9d01);
          border: 0;
          margin-top: 15px;
        "
        class="van-button van-button--primary van-button--normal van-button--round"
      >
        <div class="van-button__content">
          <span class="van-button__text">我的中奖记录</span>
        </div>
      </button>
    </div>
    <van-popup
      v-model="show"
      round
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div style="height: 50px"></div>
      <div
        v-if="lists.length > 0"
        style="height: calc(100% - 50px);overflow: auto"
      >
        <van-cell-group>
          <van-cell
            v-for="item in lists"
            :key="item.key"
            :title="item.jiang_name"
            :value="item.addtime"
          />
        </van-cell-group>
      </div>
      <van-empty
        style="height: calc(100% - 50px);overflow: auto"
        v-else
        description="暂无记录"
      />
    </van-popup>
  </div>
</template>

<script>
import Zz from "@components/Zz";
import request from "@utils/request";
import zhi from "@assets/images/h/zp3_btn1.png";
import zhi2 from "@assets/images/h/zp3_btn2.png";
import icon2 from "@assets/images/h/xyzp-pan.png";
import Vue from "vue";
import { Popup } from "vant";
import { Empty } from "vant";
import { Cell, CellGroup } from "vant";

Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Empty);
Vue.use(Popup);

export default {
  name: "zhuanpan",
  components: { Zz },
  data() {
    return {
      luckyNum: 3,
      nums: [],
      prizes: [
        // {
        //   fonts: { text: "谢谢参与", top: "85%" },
        //   imgs: { src: "/img/zp3_p0.png", width: "50%", top: "75%" },
        //   background: "#FEF3FC"
        // }
      ],
      config: {
        width: 350,
        height: 350,
        padding: 40,
        fontSize: "14px",
        fontColor: "#000",
        backgroundColor: "rgba(0, 0, 0, 0)",
        backgroundImage: icon2
        // backgroundSize: '100% 100%'
      },
      btnConfig: {
        width: "92",
        background: "rgba(0,0,0,0)",
        imgs: [
          { src: zhi, width: "120px", top: "50%" },
          { src: zhi2, width: "40px", top: "100%" }
        ]
      },
      objU: {},
      show: false,
      lists: []
    };
  },
  mounted() {
    const colors = ["#FEF3FC", "#F8DEF8"];
    request.get("/user/user/zpanindex").then(response => {
      const data = response.data.data;
      console.log("-> data", data);
      this.objU = data;
      this.nums = data.zhpan.map(v => v.proba);
      this.prizes = data.zhpan.map((v, i) => {
        return {
          id: v.id,
          name: v.name,
          num: v.num,
          index: i,
          fonts: { text: v.name, top: "85%" },
          imgs: { src: v.imgs, width: "75%", top: "60%" },
          background: i % 2 === 0 ? colors[0] : colors[1],
          proba: v.proba
        };
      });
      console.log("->  this.prizes", this.prizes);
    });
  },
  methods: {
    // 中间记录
    wayLists() {
      console.log("-> 1", 1);
      this.show = true;
      request.get("/user/user/jianglist").then(res => {
        console.log("-> res", res);
        this.lists = res.data.data || [];
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    // 随机
    getResult(arr) {
      let leng = 0;
      for (let i = 0; i < arr.length; i++) {
        leng += arr[i]; //获取总数
      }
      for (let i = 0; i < arr.length; i++) {
        var random = parseInt(Math.random() * leng); //获取 0-总数 之间的一个随随机整数
        if (random < arr[i]) {
          return i; //如果在当前的概率范围内,得到的就是当前概率
        } else {
          leng -= arr[i]; //否则减去当前的概率范围,进入下一轮循环
        }
      }
    },
    async startCallBack() {
      const data = await new Promise(resolve => {
        request.get("user/user/chouj").then(res => {
          resolve(res.data);
        });
      });
      console.log("-> data111", data);
      if (data.code === 300) {
        this.$dialog.error(data.msg);
        return false;
      }
      if (!this.luckyNum) return alert("还剩0次抽奖机会");
      this.$refs.LuckDraw.play(data.data.index + 1);
    },
    endCallBack(inx) {
      alert(`恭喜你获得大奖: ${this.prizes[inx].fonts.text}`);
      this.luckyNum--;
    }
  }
};
</script>

<style scoped>
.dd-aa {
  height: 100%;
  background-color: #7f5ce5;
  background-attachment: fixed;
  background-image: url("../../assets/images/icon.svg");
  text-align: center;
  margin: 0;
}

.zjjilu {
  position: absolute;
  bottom: 15%;
  width: 100%;
  text-align: center;
  margin-bottom: 15px;
  font-size: 18px;
  color: #ff9800;
  font-weight: 700;
}
</style>
